export const SYSTEM_COMMANDS = {
  "Wake up BLE": "0x02",
  "Battery Level ": "0x07",
  "Read DSP data": "0x06",
};

export const VOLUME_COMMANDS = {
  0: "0x10",
  1: "0x10",
  2: "0x11",
  3: "0x11",
  4: "0x12",
  5: "0x12",
  6: "0x13",
  7: "0x13",
  8: "0x14",
  9: "0x14",
  10: "0x15",
  11: "0x15",
  12: "0x16",
  13: "0x16",
  14: "0x17",
  15: "0x17",
  16: "0x18",
  17: "0x18",
  18: "0x19",
  19: "0x19",
  20: "0x1A",
  21: "0x1A",
  22: "0x1B",
  23: "0x1B",
  24: "0x1C",
  25: "0x1C",
  26: "0x1D",
  27: "0x1D",
  28: "0x1E",
  29: "0x1E",
  30: "0x1F",
};

export const EQ_LEVEL = [20, 30, 70, 50, 60];

export const MODES = {
  "0b": 0,
  "0c": 1,
  "0d": 2,
  "0e": 3,
};

export const ricOptimaChartData = {
  "250Hz": {
    0: {
      "50dB": 42,
      "65dB": 65,
      "80dB": 85,
    },
    1: {
      "50dB": 45,
      "65dB": 65,
      "80dB": 87,
    },
    2: {
      "50dB": 46,
      "65dB": 62,
      "80dB": 88,
    },
    3: {
      "50dB": 49,
      "65dB": 69,
      "80dB": 88,
    },

    4: {
      "50dB": 50,
      "65dB": 66,
      "80dB": 93,
    },
    5: {
      "50dB": 52,
      "65dB": 73,
      "80dB": 95,
    },
    6: {
      "50dB": 54,
      "65dB": 76,
      "80dB": 97,
    },
    7: {
      "50dB": 57,
      "65dB": 79,
      "80dB": 99,
    },
    8: {
      "50dB": 58,
      "65dB": 80,
      "80dB": 102,
    },
    9: {
      "50dB": 61,
      "65dB": 76,
      "80dB": 103,
    },
    10: {
      "50dB": 63,
      "65dB": 85,
      "80dB": 105,
    },
    11: {
      "50dB": 65,
      "65dB": 83,
      "80dB": 108,
    },
    12: {
      "50dB": 67,
      "65dB": 94,
      "80dB": 110,
    },
    13: {
      "50dB": 68,
      "65dB": 91,
      "80dB": 109,
    },
    14: {
      "50dB": 71,
      "65dB": 92,
      "80dB": 110,
    },
    15: {
      "50dB": 73,
      "65dB": 94,
      "80dB": 110,
    },
  },
  "600Hz": {
    0: {
      "50dB": 42,
      "65dB": 65,
      "80dB": 85,
    },
    1: {
      "50dB": 45,
      "65dB": 65,
      "80dB": 87,
    },
    2: {
      "50dB": 46,
      "65dB": 62,
      "80dB": 88,
    },
    3: {
      "50dB": 49,
      "65dB": 69,
      "80dB": 88,
    },

    4: {
      "50dB": 50,
      "65dB": 66,
      "80dB": 93,
    },
    5: {
      "50dB": 52,
      "65dB": 73,
      "80dB": 95,
    },
    6: {
      "50dB": 54,
      "65dB": 76,
      "80dB": 97,
    },
    7: {
      "50dB": 57,
      "65dB": 79,
      "80dB": 99,
    },
    8: {
      "50dB": 58,
      "65dB": 80,
      "80dB": 102,
    },
    9: {
      "50dB": 61,
      "65dB": 76,
      "80dB": 103,
    },
    10: {
      "50dB": 63,
      "65dB": 85,
      "80dB": 105,
    },
    11: {
      "50dB": 65,
      "65dB": 83,
      "80dB": 108,
    },
    12: {
      "50dB": 67,
      "65dB": 94,
      "80dB": 110,
    },
    13: {
      "50dB": 68,
      "65dB": 91,
      "80dB": 109,
    },
    14: {
      "50dB": 71,
      "65dB": 92,
      "80dB": 110,
    },
    15: {
      "50dB": 73,
      "65dB": 94,
      "80dB": 110,
    },
  },
  "1800Hz": {
    0: {
      "50dB": 52,
      "65dB": 67,
      "80dB": 83,
    },
    1: {
      "50dB": 54,
      "65dB": 69,
      "80dB": 84,
    },
    2: {
      "50dB": 57,
      "65dB": 72,
      "80dB": 87,
    },
    3: {
      "50dB": 58,
      "65dB": 74,
      "80dB": 89,
    },

    4: {
      "50dB": 61,
      "65dB": 76,
      "80dB": 91,
    },
    5: {
      "50dB": 63,
      "65dB": 77,
      "80dB": 93,
    },
    6: {
      "50dB": 64,
      "65dB": 80,
      "80dB": 95,
    },
    7: {
      "50dB": 64,
      "65dB": 82,
      "80dB": 97,
    },
    8: {
      "50dB": 68,
      "65dB": 84,
      "80dB": 99,
    },
    9: {
      "50dB": 70,
      "65dB": 85,
      "80dB": 101,
    },
    10: {
      "50dB": 72,
      "65dB": 88,
      "80dB": 103,
    },
    11: {
      "50dB": 75,
      "65dB": 90,
      "80dB": 105,
    },
    12: {
      "50dB": 76,
      "65dB": 92,
      "80dB": 106,
    },
    13: {
      "50dB": 79,
      "65dB": 94,
      "80dB": 106,
    },
    14: {
      "50dB": 80,
      "65dB": 96,
      "80dB": 106,
    },
    15: {
      "50dB": 82,
      "65dB": 98,
      "80dB": 106,
    },
  },
  "2700Hz": {
    0: {
      "50dB": 53,
      "65dB": 69,
      "80dB": 84,
    },
    1: {
      "50dB": 56,
      "65dB": 71,
      "80dB": 86,
    },
    2: {
      "50dB": 58,
      "65dB": 72,
      "80dB": 87,
    },
    3: {
      "50dB": 60,
      "65dB": 74,
      "80dB": 90,
    },

    4: {
      "50dB": 61,
      "65dB": 76,
      "80dB": 92,
    },
    5: {
      "50dB": 64,
      "65dB": 78,
      "80dB": 93,
    },
    6: {
      "50dB": 66,
      "65dB": 81,
      "80dB": 96,
    },
    7: {
      "50dB": 67,
      "65dB": 82,
      "80dB": 97,
    },
    8: {
      "50dB": 69,
      "65dB": 84,
      "80dB": 98,
    },
    9: {
      "50dB": 71,
      "65dB": 86,
      "80dB": 101,
    },
    10: {
      "50dB": 72,
      "65dB": 88,
      "80dB": 102,
    },
    11: {
      "50dB": 74,
      "65dB": 89,
      "80dB": 105,
    },
    12: {
      "50dB": 77,
      "65dB": 92,
      "80dB": 106,
    },
    13: {
      "50dB": 79,
      "65dB": 94,
      "80dB": 108,
    },
    14: {
      "50dB": 81,
      "65dB": 96,
      "80dB": 110,
    },
    15: {
      "50dB": 83,
      "65dB": 98,
      "80dB": 111,
    },
  },
  "3500Hz": {
    0: {
      "50dB": 50,
      "65dB": 65,
      "80dB": 80,
    },
    1: {
      "50dB": 53,
      "65dB": 68,
      "80dB": 82,
    },
    2: {
      "50dB": 55,
      "65dB": 69,
      "80dB": 84,
    },
    3: {
      "50dB": 57,
      "65dB": 71,
      "80dB": 86,
    },

    4: {
      "50dB": 58,
      "65dB": 74,
      "80dB": 88,
    },
    5: {
      "50dB": 60,
      "65dB": 75,
      "80dB": 90,
    },
    6: {
      "50dB": 62,
      "65dB": 78,
      "80dB": 92,
    },
    7: {
      "50dB": 63,
      "65dB": 80,
      "80dB": 95,
    },
    8: {
      "50dB": 66,
      "65dB": 82,
      "80dB": 97,
    },
    9: {
      "50dB": 68,
      "65dB": 83,
      "80dB": 98,
    },
    10: {
      "50dB": 70,
      "65dB": 85,
      "80dB": 100,
    },
    11: {
      "50dB": 72,
      "65dB": 87,
      "80dB": 102,
    },
    12: {
      "50dB": 74,
      "65dB": 89,
      "80dB": 104,
    },
    13: {
      "50dB": 76,
      "65dB": 92,
      "80dB": 105,
    },
    14: {
      "50dB": 77,
      "65dB": 93,
      "80dB": 107,
    },
    15: {
      "50dB": 80,
      "65dB": 95,
      "80dB": 108,
    },
  },
  "4300Hz": {
    0: {
      "50dB": 50,
      "65dB": 65,
      "80dB": 80,
    },
    1: {
      "50dB": 53,
      "65dB": 68,
      "80dB": 82,
    },
    2: {
      "50dB": 55,
      "65dB": 69,
      "80dB": 84,
    },
    3: {
      "50dB": 57,
      "65dB": 71,
      "80dB": 86,
    },

    4: {
      "50dB": 58,
      "65dB": 74,
      "80dB": 88,
    },
    5: {
      "50dB": 60,
      "65dB": 75,
      "80dB": 90,
    },
    6: {
      "50dB": 62,
      "65dB": 78,
      "80dB": 92,
    },
    7: {
      "50dB": 63,
      "65dB": 80,
      "80dB": 95,
    },
    8: {
      "50dB": 66,
      "65dB": 82,
      "80dB": 97,
    },
    9: {
      "50dB": 68,
      "65dB": 83,
      "80dB": 98,
    },
    10: {
      "50dB": 70,
      "65dB": 85,
      "80dB": 100,
    },
    11: {
      "50dB": 72,
      "65dB": 87,
      "80dB": 102,
    },
    12: {
      "50dB": 74,
      "65dB": 89,
      "80dB": 104,
    },
    13: {
      "50dB": 76,
      "65dB": 92,
      "80dB": 105,
    },
    14: {
      "50dB": 77,
      "65dB": 93,
      "80dB": 107,
    },
    15: {
      "50dB": 80,
      "65dB": 95,
      "80dB": 108,
    },
  },
  "6000Hz": {
    0: {
      "50dB": 44,
      "65dB": 59,
      "80dB": 76,
    },
    1: {
      "50dB": 46,
      "65dB": 61,
      "80dB": 77,
    },
    2: {
      "50dB": 47,
      "65dB": 62,
      "80dB": 77,
    },
    3: {
      "50dB": 48,
      "65dB": 62,
      "80dB": 77,
    },

    4: {
      "50dB": 48,
      "65dB": 63,
      "80dB": 78,
    },
    5: {
      "50dB": 49,
      "65dB": 64,
      "80dB": 79,
    },
    6: {
      "50dB": 51,
      "65dB": 65,
      "80dB": 80,
    },
    7: {
      "50dB": 52,
      "65dB": 66,
      "80dB": 81,
    },
    8: {
      "50dB": 52,
      "65dB": 67,
      "80dB": 82,
    },
    9: {
      "50dB": 53,
      "65dB": 68,
      "80dB": 84,
    },
    10: {
      "50dB": 54,
      "65dB": 69,
      "80dB": 84,
    },
    11: {
      "50dB": 54,
      "65dB": 71,
      "80dB": 86,
    },
    12: {
      "50dB": 57,
      "65dB": 72,
      "80dB": 88,
    },
    13: {
      "50dB": 59,
      "65dB": 74,
      "80dB": 89,
    },
    14: {
      "50dB": 60,
      "65dB": 75,
      "80dB": 90,
    },
    15: {
      "50dB": 61,
      "65dB": 76,
      "80dB": 91,
    },
  },
  "8000Hz": {
    0: {
      "50dB": 44,
      "65dB": 59,
      "80dB": 76,
    },
    1: {
      "50dB": 46,
      "65dB": 61,
      "80dB": 77,
    },
    2: {
      "50dB": 47,
      "65dB": 62,
      "80dB": 77,
    },
    3: {
      "50dB": 48,
      "65dB": 62,
      "80dB": 77,
    },

    4: {
      "50dB": 48,
      "65dB": 63,
      "80dB": 78,
    },
    5: {
      "50dB": 49,
      "65dB": 64,
      "80dB": 79,
    },
    6: {
      "50dB": 51,
      "65dB": 65,
      "80dB": 80,
    },
    7: {
      "50dB": 52,
      "65dB": 66,
      "80dB": 81,
    },
    8: {
      "50dB": 52,
      "65dB": 67,
      "80dB": 82,
    },
    9: {
      "50dB": 53,
      "65dB": 68,
      "80dB": 84,
    },
    10: {
      "50dB": 54,
      "65dB": 69,
      "80dB": 84,
    },
    11: {
      "50dB": 54,
      "65dB": 71,
      "80dB": 86,
    },
    12: {
      "50dB": 57,
      "65dB": 72,
      "80dB": 88,
    },
    13: {
      "50dB": 59,
      "65dB": 74,
      "80dB": 89,
    },
    14: {
      "50dB": 60,
      "65dB": 75,
      "80dB": 90,
    },
    15: {
      "50dB": 61,
      "65dB": 76,
      "80dB": 91,
    },
  },
};

export const frequenciesRic8 = [
  "250Hz",
  "600Hz",
  "1800Hz",
  "2700Hz",
  "3500Hz",
  "4300Hz",
  "6000Hz",
  "8000Hz",
];

export const frequenciesRic8Lables = [
  "250",
  "600",
  "1.8k",
  "2.7k",
  "3.5k",
  "4.3k",
  "6k",
  "8k",
];
